import {
    focusManager,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { AppState, type AppStateStatus } from 'react-native';
import { isWeb } from 'smoothie';

import type { ContainerComponent } from '../../common/types/Common';
import QueryDevTools from './QueryDevTools';

// Add native support for option to refetch on app focus
// https://tanstack.com/query/v4/docs/react/guides/window-focus-refetching#managing-focus-in-react-native
const onAppStateChange = (status: AppStateStatus) => {
    if (!isWeb) {
        focusManager.setFocused(status === 'active');
    }
};

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

const DataFetchingProvider: ContainerComponent = ({ children }) => {
    useEffect(() => {
        if (isWeb) {
            return;
        }

        const subscription = AppState.addEventListener(
            'change',
            onAppStateChange,
        );
        return () => {
            subscription.remove();
        };
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <QueryDevTools client={queryClient} />
        </QueryClientProvider>
    );
};

export default DataFetchingProvider;
